<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-html="renderedContent"></div>
</template>

<script setup lang="ts">
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { computed } from 'vue';

const props = defineProps<{
  text: string | null | undefined;
}>();

const renderedContent = computed(() => renderWithKatex(props.text ?? ''));

function renderWithKatex(content: string): string {
  const expressionRegex = /\$\$([\s\S]+?)\$\$/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let rendered = '';

  while ((match = expressionRegex.exec(content)) !== null) {
    const beforeMatch = content.slice(lastIndex, match.index);
    rendered += beforeMatch;

    const expression = match[1];
    try {
      rendered += katex.renderToString(expression, {
        throwOnError: false,
        displayMode: false,
      });
    } catch {
      rendered += match[0];
    }
    lastIndex = expressionRegex.lastIndex;
  }

  rendered += content.slice(lastIndex);
  return rendered;
}
</script>
